<div class="body">
    <mat-toolbar>
        <button mat-icon-button>
            <mat-icon>notifications_none</mat-icon>
        </button>
        <span>Benachrichtigungen</span>
        <span class="spacer"></span>
        <button mat-icon-button (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar>
    <div class="content widget-list-content" style="overflow-y: auto; max-height: 80vh;" [formGroup]="formGroup">

        <quill-editor formControlName="notificationtext" format="html" class="quill-note" [modules]="{'toolbar':false}" style="flex: 1;"></quill-editor>
        
        <div class="footer-wrapper">
            <button mat-raised-button color="primary" (click)="markMessageAsSeen()">Ok</button>
            <button mat-raised-button *ngIf="notificationSeenControl.value" (click)="markMessageAsUnseen()">Als ungelesen markieren</button>
        </div>

    </div>

</div>